export default __webpack_public_path__ + "static/github-convert-d2d3a8baa2c81c38290df5be21731363.png";